import React, { useEffect, useState } from "react";
import ChartSection from "../ChartSection";
import { Impressionchart } from "../Impressionchart";
import Engagementchart from "./Engagementchart";
import { useSelector } from "react-redux";
import { getArrowDirection } from "../../services/activity";

export default function Overview() {
  const { groupAnaytics } = useSelector((state) => state.Analytics);

  const [totalTaps, setTotalTaps] = useState(0);
  const [followerCount, setFollowerCount] = useState(0);
  const [totalSum, setTotalSum] = useState(0);
  const [engagementCount, setEngagementCount] = useState(0);

  const [percentageFollowerChange, setPercentageFollowerChange] = useState(0);
  const [percentageImpressionsChange, setPercentageImpressionsChange] = useState(0);
  const [percentageEngagementChange, setPercentageEngagementChange] = useState(0);
  const [percentageTapsChange, setPercentageTapsChange] = useState(0); // State for Post Link Clicks
  const [percentageEngagementRateChange, setPercentageEngagementRateChange] = useState(0); // State for Engagement Rate

  useEffect(() => {
    if (groupAnaytics) {
      let totalTapsAccum = 0;
      let followerCountAccum = 0;
      let totalSumAccum = 0;
      let totalEngagementAccum = 0;

      let previousFollowerCount = 0;
      let previousTotalSum = 0;
      let previousEngagements = 0;
      let previousTaps = 0;
      let previousEngagementRate = 0;

      // === INSTAGRAM ===
      const instagramData = groupAnaytics?.INSTAGRAM || [];
      instagramData.forEach((instagram) => {
        const followers = instagram?.followersCount || 0;
        const engagement = instagram?.totalEngagement || 0;
        const impressions = instagram?.totalImpression || 0;
        const comments = instagram?.mediaAnalytics?.length || 0;
        const shares = instagram?.data?.find((m) => m.name === "shares")?.total_value?.value || 0;
        const taps = instagram?.data?.find((m) => m.name === "profile_links_taps")?.total_value?.value || 0;

        followerCountAccum += followers;
        totalSumAccum += engagement + impressions + comments + shares + taps;
        totalEngagementAccum += engagement;
        totalTapsAccum += taps;
      });

      // === PINTEREST ===
      const pinterestData = groupAnaytics?.PINTEREST || [];
      pinterestData.forEach((pinterest) => {
        const impressions = pinterest?.all?.summary_metrics?.IMPRESSION || 0;
        const clicks = pinterest?.all?.summary_metrics?.OUTBOUND_CLICK || 0;

        totalSumAccum += impressions + clicks;
        totalTapsAccum += clicks;
        totalEngagementAccum += clicks; // assuming clicks = engagement here
      });

      // === FACEBOOK ===
      const facebookData = groupAnaytics?.FACEBOOK || [];
      facebookData.forEach((facebook) => {
        const follows = facebook?.followerCount || 0;
        const engagement = facebook?.totalEngagement || 0;
        const impressions = facebook?.totalImpression || 0;

        totalSumAccum += engagement + impressions + follows;
        totalTapsAccum += follows;
        totalEngagementAccum += engagement;
      });

      // === PREVIOUS PERIOD DATA ===
      const previousData = groupAnaytics?.previousPeriod || {};

      (previousData?.INSTAGRAM || []).forEach((instagram) => {
        previousFollowerCount += instagram?.followersCount || 0;
        previousTotalSum += instagram?.totalEngagement || 0;
        previousTotalSum += instagram?.totalImpression || 0;
        previousTotalSum += instagram?.mediaAnalytics?.length || 0;
        previousTotalSum += instagram?.data?.find((m) => m.name === "shares")?.total_value?.value || 0;
        previousTotalSum += instagram?.data?.find((m) => m.name === "profile_links_taps")?.total_value?.value || 0;

        previousEngagements += instagram?.totalEngagement || 0;
        previousTaps += instagram?.data?.find((m) => m.name === "profile_links_taps")?.total_value?.value || 0;
      });

      (previousData?.PINTEREST || []).forEach((pinterest) => {
        const clicks = pinterest?.all?.summary_metrics?.OUTBOUND_CLICK || 0;
        previousTotalSum += clicks;
        previousEngagements += clicks; // treating clicks as engagement
        previousTaps += clicks; // treating clicks as taps
      });

      (previousData?.FACEBOOK || []).forEach((facebook) => {
        const engagement = facebook?.totalEngagement || 0;
        const impressions = facebook?.totalImpression || 0;
        const follows = facebook?.followerCount || 0;

        previousTotalSum += engagement + impressions + follows;
        previousEngagements += engagement;
        previousTaps += follows; // treating follows as taps
      });

      // === SET STATES ===
      setFollowerCount(followerCountAccum);
      setTotalSum(totalSumAccum);
      setTotalTaps(totalTapsAccum);
      setEngagementCount(totalEngagementAccum)

      const followerChange = previousFollowerCount === 0 ? 0 : ((followerCountAccum - previousFollowerCount) / previousFollowerCount) * 100;
      const impressionChange = previousTotalSum === 0 ? 0 : ((totalSumAccum - previousTotalSum) / previousTotalSum) * 100;
      const engagementChange = previousEngagements === 0 ? 0 : ((totalEngagementAccum - previousEngagements) / previousEngagements) * 100;
      const tapsChange = previousTaps === 0 ? 0 : ((totalTapsAccum - previousTaps) / previousTaps) * 100;
      const engagementRateChange = previousTotalSum === 0 ? 0 : ((totalEngagementAccum / totalSumAccum) - (previousEngagements / previousTotalSum)) * 100;

      setPercentageFollowerChange(followerChange);
      setPercentageImpressionsChange(impressionChange);
      setPercentageEngagementChange(engagementChange);
      setPercentageTapsChange(tapsChange);
      setPercentageEngagementRateChange(engagementRateChange);
    }
  }, [groupAnaytics]);

  return (
    <div>
      <div className="summery_section">
        <div className="summary_head_box">
          <h4>Performance Summary</h4>
          <label>View your key profile performance metrics from the reporting period.</label>
        </div>

        <div>
          <table className="table summary_table">
            <tbody>
              <tr>
                <td>
                  <label className="summaryHead">Followers</label>
                  <div className="d-flex align-items-center mt-3">
                    <span className="total_numbers">{followerCount}</span>
                    <span className="differance_percentage">
                         <i   className={`fa ${getArrowDirection(percentageFollowerChange).icon}`}
                            aria-hidden="true"
                            style={{ color: getArrowDirection(percentageFollowerChange).color }}></i>
                      {percentageFollowerChange.toFixed(2)}%
                    </span>
                  </div>
                </td>

                <td>
                  <label className="summaryHead">Impressions</label>
                  <div className="d-flex align-items-center mt-3">
                    <span className="total_numbers">{isNaN(totalSum) ? 0 : totalSum}</span>
                    <span className="differance_percentage">
                      <i   className={`fa ${getArrowDirection(percentageImpressionsChange).icon}`}
                            aria-hidden="true"
                            style={{ color: getArrowDirection(percentageImpressionsChange).color }}></i>
                      {percentageImpressionsChange.toFixed(2)}%
                    </span>
                  </div>
                </td>

                <td>
                  <label className="summaryHead">Engagements</label>
                  <div className="d-flex align-items-center mt-3">
                    <span className="total_numbers">{engagementCount}</span>
                    <span className="differance_percentage">
                      <i   className={`fa ${getArrowDirection(percentageEngagementChange).icon}`}
                            aria-hidden="true"
                            style={{ color: getArrowDirection(percentageImpressionsChange).color }}></i>
                      {percentageEngagementChange.toFixed(2)}%
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                  <label className="summaryHead">Post Link Clicks</label>
                  <div className="d-flex align-items-center mt-3">
                    <span className="total_numbers">{totalTaps}</span>
                    <span className="differance_percentage">
                       <i   className={`fa ${getArrowDirection(percentageTapsChange).icon}`}
                            aria-hidden="true"
                            style={{ color: getArrowDirection(percentageTapsChange).color }}></i>
                      {percentageTapsChange.toFixed(2)}%
                    </span>
                  </div>
                </td>

                <td colSpan={2}>
                  <label className="summaryHead">Engagement Rate (per Impression)</label>
                  <div className="d-flex align-items-center mt-3">
                    <span className="total_numbers">
                      {(engagementCount / (totalSum || 1)).toFixed(2)}
                    </span>
                    <span className="differance_percentage">
                      <i   className={`fa ${getArrowDirection(percentageEngagementRateChange).icon}`}
                            aria-hidden="true"
                            style={{ color: getArrowDirection(percentageEngagementRateChange).color }}></i>
                      {percentageEngagementRateChange.toFixed(2)}%
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-5">
        <ChartSection  />
        <div className="mt-5">
          <Impressionchart />
        </div>
        <div className="mt-5">
          <Engagementchart />
        </div>
      </div>
    </div>
  );
}
